import styled, { css } from 'styled-components'
import { theme } from './../../common'

export const StyledButton = styled.button`
    font-weight: bold;
    color: ${theme.white};
    padding: 5px 40px;
    border-radius: 0px;
    z-index: 10;
    ${
        ({color}) => {
            if(color === 'primary') {
                return css`
                    background-color: ${theme.primary};
                    &:hover {
                        color: ${theme.white}
                    }
                `
            }
        }
    }

    ${
        ({width}) => width && css`width: ${width}`
    }

    ${
        ({fontSize}) => fontSize && `font-size: ${fontSize}`
    }
`